import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { getExactPathMatch } from '../getExactPathMatch';

import { useStaticUrls } from './useStaticUrls';

/**
 * Возвращает параметры из всех совпадающих путей
 * независимо от расположения текущего компонента в иерархии роутера
 *
 * @see https://github.com/remix-run/react-router/issues/5870
 */
export function useExactMatchParams() {
    const staticUrls = useStaticUrls();
    const { pathname } = useLocation();

    return useMemo(() => getExactPathMatch(staticUrls, pathname)?.params || {}, [pathname, staticUrls]);
}
